import {
  ListTaxWithholdingTransactionsFilterParameterStatusEq as TaxWithholdingTransactionStatus,
  TaxWithholdingTransaction,
  TaxWithholdingTransactionType
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Groups the tax-withholding transaction feed into the three sections the
 * dashboard renders, preserving the pre-v3 buckets:
 * - `scheduled` — future IRS payments (`Scheduled` tax payments).
 * - `processing` — anything in flight: `Processing` movements plus any
 *   non-tax-payment that is still `Scheduled` (in-flight set-asides/deposits).
 * - `posted` — settled ledger movements.
 *
 * The feed is source-grouped rather than globally chronological, so callers must
 * pass every row they mean to bucket (e.g. `useQueryAll().flatData`) rather than a
 * single page. Passing a `status`-filtered feed (e.g. only `Scheduled`/`Processing`)
 * is fine — the buckets for the omitted statuses simply come back empty.
 */
export const selectorGroupedTaxWithholdingTransactions = (
  transactions: TaxWithholdingTransaction[]
): {
  scheduled: TaxWithholdingTransaction[];
  processing: TaxWithholdingTransaction[];
  posted: TaxWithholdingTransaction[];
} => ({
  scheduled: transactions.filter(
    transaction =>
      transaction.status === TaxWithholdingTransactionStatus.SCHEDULED &&
      transaction.type === TaxWithholdingTransactionType.TAX_PAYMENT
  ),
  processing: transactions.filter(
    transaction =>
      transaction.status === TaxWithholdingTransactionStatus.PROCESSING ||
      (transaction.status === TaxWithholdingTransactionStatus.SCHEDULED &&
        transaction.type !== TaxWithholdingTransactionType.TAX_PAYMENT)
  ),
  posted: transactions.filter(
    transaction => transaction.status === TaxWithholdingTransactionStatus.POSTED
  )
});
